import { ApplicationConfig, provideBrowserGlobalErrorListeners, APP_INITIALIZER, inject } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { routes } from './app.routes';
import { PUBLIC_API_BASE_URL } from '@frontend/public-calendar';
import { API_BASE_URL } from '@frontend/util';
import { environment } from '../environments/environment';
import { TenantConfigService } from './services/tenant-config.service';
import { firstValueFrom } from 'rxjs';

/**
 * Initializes the app by checking tenant configuration from the Worker.
 * If the tenant doesn't exist (404 from /config.json), redirects to /not-found.
 */
function initializeTenantConfig(): () => Promise<void> {
  const tenantService = inject(TenantConfigService);
  return async () => {
    await firstValueFrom(tenantService.fetchConfig());
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withFetch()),
    { provide: PUBLIC_API_BASE_URL, useValue: environment.apiUrl },
    { provide: API_BASE_URL, useValue: environment.apiUrl },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeTenantConfig,
      multi: true,
    },
  ],
};
